import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceService } from 'app/core/services/device.service';
import { UserService } from 'app/core/services/user.service';
import { IAuthNewUserData } from 'app/interface/auth.new.interface';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
	@Input() user: IAuthNewUserData;
	@Input() isOpen: boolean = true;
	@Output() close = new EventEmitter<void>();
	isMobile: boolean = false;
	navigation = [
		{
			id: 'tester-sign-up',
			title: 'Tester Sign Up',
			type: 'basic',
			icon: 'menu-tester-signup',
			link: 'sign-up-flow'
		},
		{
			id: 'beta-test',
			title: 'Beta Test',
			type: 'basic',
			icon: 'menu-beta-test',
			link: 'beta-test'
		},
		{
			id: 'community',
			title: 'Community',
			type: 'basic',
			icon: 'menu-community',
			link: 'community'
		},
		{
			id: 'play-menu',
			title: '$PLAY',
			type: 'basic',
			icon: 'menu-play',
			link: 'play-menu'
		},
		// {
		// 	id: 'leaderboards',
		// 	title: 'Leaderboards',
		// 	type: 'basic',
		// 	icon: 'menu-leaderboards',
		// 	link: 'leaderboards/view-leaderboards',
		// },
		{
			id: 'events',
			title: 'Events',
			type: 'basic',
			icon: 'reward_icon',
			link: 'events'
		}
	];

	constructor(
		private confirmationService: ConfirmationService,
		private device: DeviceService,
		private messageService: MessageService,
		private userService: UserService
	) {
		this.isMobile = this.device.isMobile();
	}

	onNavigation(): void {
		if (this.device.isMobile()) this.close.emit();
	}

	deleteAccount(event: Event): void {
		this.confirmationService.confirm({
			target: event.target as EventTarget,
			message: `By proceeding with account deletion, you acknowledge that all progress, data, and information associated with this account will be permanently lost. This includes, but is not limited to:
			- Game progression, achievements, and rewards.
			- Items, purchases, or currencies tied to your account.
			- Data or progression in multiple games that are linked to this account.
			Please note that once deleted, your account and its data cannot be recovered. This action is irreversible and may impact your ability to access or continue progress in any connected games or services.
			Are you sure you want to proceed?
			`,
			header: 'Account Deletion Confirmation',
			rejectLabel: 'Cancel',
			acceptLabel: 'Delete my Account',
			acceptButtonStyleClass: 'custom-accept-button',
			rejectButtonStyleClass: 'custom-reject-button',
			accept: () => {
				this.userService.deleteUserAccount().subscribe((data) => {
					console.log(data);
					this.messageService.add({ severity: 'warn', summary: 'Deleted', detail: 'You have deleted your account', life: 3000 });
				})
			},
			reject: () => {
				this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
			}
		});
	}
}
